<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Design Help Terms</h1>
    </header>
    <div class="modal-body">
        <input type="checkbox" id="term" [(ngModel)]="terms">
        <p i18n>
            I confirm that i understand and need to use a high-quality image to achieve the best results with the background image. <a href="https://ancytree.com/hjalp/#hjalppaket" target="_blank" >Read more about it here</a>
        </p>
    </div>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" mat-dialog-close="success" [disabled]="!terms">
            OK
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Cancel
        </button>
    </footer>
</div>